import { render, staticRenderFns } from "./OperationSidebar.vue?vue&type=template&id=781ffa2a&"
import script from "./OperationSidebar.vue?vue&type=script&lang=js&"
export * from "./OperationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports